import { Fragment } from "react";
import usePlaidFunding from "./usePlaidFunding";
import color from "context/MaterialUITheme/color";
import Typography from "@mui/material/Typography";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import { useNavigate } from "react-router-dom";
import useTracker from "components/CTracker/useTrackerContext";

const FundingVerification: React.FC = () => {
  const plaid = usePlaidFunding();
  const { loan } = useTracker();
  const navigate = useNavigate();
  const borrowerSteps = loan?.borrowerSteps;
  const disclosuresStatus = borrowerSteps?.finalDisclosuresVerification?.status;
  const status = borrowerSteps?.fundingVerification?.status ?? "pending";
  const message = borrowerSteps?.fundingVerification?.message ?? "";

  return (
    <Fragment>
      <CTrackerTimelineItem
        last
        status={status}
        title="Funding"
        tooltip="Tell us where you want the funds to go. We’ll send them, and then you’re all set, congrats!"
        {...(status === "pending" &&
          disclosuresStatus === "success" && {
            action: {
              message: "Select your bank account for funding",
              onClick: () => {
                plaid.load();
              },
            },
          })}
        {...(status === "success" && {
          action: {
            message: "Check your loan",
            onClick: () => navigate("/home-monitor"),
          },
        })}
        {...(plaid.isWaitingForMicroTransactions &&
          !loan?.borrowerSteps?.fundingVerification.routingNumber &&
          status === "analyzing" && {
            action: {
              message: "Verify your bank account",
              onClick: plaid.load,
            },
          })}
      >
        <Typography
          variant="h6"
          sx={{
            color: color[trackerStatusColor[status] as keyof typeof color],
          }}
        >
          {status === "analyzing" && message}
          {status === "failed" && message}
          {status === "success" && message}
        </Typography>
      </CTrackerTimelineItem>
    </Fragment>
  );
};

export default FundingVerification;
